<template>
  <div class="VideoCards">
    <VideoCardsItem class="card" v-for="item in listData" :key="item.id" :data="item"
    :videoId="`videoCardsItem-${item.id}`">
    </VideoCardsItem>
  </div>
</template>

<script>
import VideoCardsItem from "@/components/VideoPlayer/VideoCardsItem";
export default {
  name: "VideoCards",
  props: {
    listData: {
      type: Array,
      default: [],
    },
  },
  components: {
    VideoCardsItem,
  },
  data() {
    return {};
  },
  computed: {},
  methods: {},
  created() {},
  mounted() {},
};
</script>

<style lang="scss" scoped>
.VideoCards {
  width: 100%;
  height: 100%;
  @include setFlexBetween;
  flex-wrap: wrap;
  .card {
    width: calc(50% - 6px);
    height: 100%;
  }
}
</style>
